import * as React from "react";
interface SVGProps {
  height?: number | string;
  width?: number | string;
  color?: string;
}

const SvgLinkedin = (props: SVGProps) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 21 21" fill="none" {...props}>
      <path
        d="M4.379 3.742a2.079 2.079 0 01-2.071 2.087A2.079 2.079 0 01.237 3.742a2.08 2.08 0 012.07-2.088A2.08 2.08 0 014.38 3.742zm.016 3.757H.22v13.36h4.175V7.5zm6.665 0H6.912v13.36h4.149v-7.013c0-3.9 5.034-4.218 5.034 0v7.013h4.165V12.4c0-6.579-7.45-6.34-9.2-3.1v-1.8z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgLinkedin;
